module.exports = __webpack_public_path__ + "static/media/phone-image.8a62aa23.png";